import {Action} from '@clients/shared/models';

export class EmptyAction implements Action {
    public readonly type = 'EMPTY_ACTION';
}
